import { useQuery } from "@tanstack/react-query"
import api from "api"
import { queries } from "api/queries"

/**
 * Passive status check only - always sends `generateMagicLink: false`, so
 * it's safe to call on render and on a poll interval without disturbing
 * any magic link the learner already has open. Use
 * `api.bePracticeInterview.launch({ data: { generateMagicLink: true } })`
 * directly from the learner's Start/Continue click to get a fresh,
 * redirectable link.
 */
export const useLaunchPracticeInterview = (enabled: boolean) =>
  useQuery({
    queryKey: queries.bePracticeInterview.launch().queryKey,
    queryFn: () =>
      api.bePracticeInterview.launch({ data: { generateMagicLink: false } }),
    enabled,
    refetchOnWindowFocus: true,
    refetchInterval: data =>
      data?.status === "complete" && data?.reportStatus === "pending"
        ? 10000
        : false,
  })
